import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UtilService {
    private _isMobile: boolean = false;
    toggleSideNav = new BehaviorSubject<boolean>(false);
    constructor() {
        this.checkScreenSize();
    }

    checkScreenSize() {
        if (window.screen.width < 768) {
            this._isMobile = true;
        }
    }

    isMobile() {
        return this._isMobile;
    }
}